<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

    <div class="vx-row mb-2">
      <div class="vx-col w-full mb-4">
        <label class="label" for="notificationType">Notification Type</label>
        <v-select
          id="notificationType"
          :clearable=false
          color="success"
          v-model="selectedNotificationType"
          :options="notificationOptions"
          :disabled="disableSend === true"/>
      </div>
      <div class="vx-col w-full mb-2">
        <label class="label">Filters</label>
        <vs-switch
          id="usingFilters"
          color="success"
          v-model="usingFilters"
          :disabled="disableSend === true"/>
      </div>

      <template v-if="usingFilters">
        <div class="vx-col w-full mb-2">
          <label class="label" for="activeUsers">Membership Status</label>
          <v-select
            id="activeUsers"
            color="success"
            v-model="activeUsers"
            :options="activeUserOptions"
            :disabled="disableSend === true"/>
        </div>
        <div class="vx-col w-full mb-2">
          <label class="label" for="selectCompanies">Companies</label>
          <v-select
            id="selectCompanies"
            class="select2"
            multiple="multiple"
            :options="companies"
            v-model="selectedCompanies"/>
        </div>
      </template>

      <div class="vx-col w-full">
        <div v-if="!usingFilters" class="vx-col w-full">
          <span class="label">Tokens can be separated by either <b>commas</b> or <b>new lines</b> (or both)</span>
        </div>
        <div class="vx-col w-full">
          <span class="label">({{ userIds.length }}) userIds found</span>
        </div>
        <vs-textarea
          v-if="!usingFilters"
          label="User IDs"
          v-model="userIdsString"
          v-on:input="parseUserIds"
          class="w-full"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fcmHelpers } from '@/models/helpers';

const comma = ",";
const newLine = "\n";
const commaNewLine = `${comma}${newLine}`;

  export default {
    data() {
      return {
        fcmHelpers: fcmHelpers,
        loading: false,
        userIdsString: '',
        usingFilters: false,
        activeUsers: { label: "All", value: true },
        selectedNotificationType: { label: "Push Notification", value: "notification" },
        notificationOptions: [
          { label: "Push Notification", value: "notification" },
          { label: "In-App Notification", value: "data" },
          { label: "Push Notification + In-App", value: "notification-data" }
        ],
        activeUserOptions: [
          { label: "All", value: null },
          { label: "Active", value: true },
          { label: "Inactive", value: false }
        ],
        selectedCompanies: [],
      }
    },
    props: {
      filters: Object,
      companies: Array,
      disableSend: Boolean,
      getFilteredUserIds: Function,
      userIds: Array,
      notificationType: String,
      setIsLoading: Function
    },
    watch: {
      selectedNotificationType(val) {
        this.$emit('notificationTypeChanged', val.value);
      },
      userIds(val) {
        this.userIds = val;
      },
      usingFilters(val) {
        if (!val) {
          this.activeUsers = { label: "Active", value: true };
          this.selectedCompanies = [];
          delete this.filters.membership_active;
          delete this.filters.company;
        }
        this.getUserIds();
      },
      async activeUsers(val) {
        if (val.value !== null) {
          this.filters.membership_active = val.value;
        }
        else {
          delete this.filters.membership_active;
        }
        await this.getUserIds();
      },
      selectedCompanies(val) {
        if (!val || !val.length){
          delete this.filters.company;
        }
        else {
          this.filters.company = val.map((company) => company.value);
        }
        this.getUserIds();
      }
    },
    methods: {
      async getUserIds() {
        this.setIsLoading(true);
        if (this.usingFilters) {
          this.userIds = await this.getFilteredUserIds();
        }
        else {
          this.parseUserIds();
        }
        this.setIsLoading(false);
      },
      parseUserIds() {
        this.userIds = [];

        let tempArray;
        if (this.userIdsString.indexOf(commaNewLine) !== -1) {
          tempArray = this.userIdsString.split(commaNewLine)
        } else if (this.userIdsString.indexOf(comma) !== -1) {
          tempArray = this.userIdsString.split(comma)
        } else if (this.userIdsString.indexOf(newLine) !== -1) {
          tempArray = this.userIdsString.split(newLine)
        } else {
          // it seems to only be 1 entry
          tempArray = [ this.userIdsString ];
        }

        // trim all the userIds
        for (let i = 0; i < tempArray.length; i++) {
          let parsed = parseInt(tempArray[i].trim());
          if (parsed && this.userIds.indexOf(parsed) === -1) {
            this.userIds.push(parsed);
          }
        }

        this.$emit('userIdsChanged', this.userIds);
      }
    },
  }
</script>
